import axios, { isAxiosError } from 'axios'
import { useQuery } from '@tanstack/react-query'
import { useConfig } from '../contexts/ConfigProvider'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useStatusChecker = (tenant: string, locale: string, initialData: any) => {
  const config = useConfig()
  const checkHelpCenterStatus = async ({ tenant, locale }: { tenant: string; locale: string }) => {
    try {
      const res = await axios.get(`${config.careHubApi}/${tenant?.toLowerCase()}/${locale?.toLowerCase()}/helpcenter/banner/status`, { timeout: 5000 })
      if (!res?.data) return null

      return res.data
    } catch (error) {
      if (isAxiosError(error) && error.response && error.response.status === 404) {
        return null
      }
      throw error
    }
  }

  return useQuery({
    queryKey: ['status', tenant, locale],
    queryFn: () => checkHelpCenterStatus({ tenant, locale }),
    staleTime: Infinity,
    retry: 2,
    initialData: initialData || undefined,
  })
}

export default useStatusChecker
